.foldableList {
  padding-bottom: 10px;
}

.expandButton {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue);

  &:hover {
    color: var(--darkBlue);
  }
}

.noElements {
  color: var(--darkSilver);
}

.listEntries {
  padding: 1em;
}

.item {
  padding: 0.3em;

  &:nth-child(odd) {
    background: var(--silver);
  }
}

.headers > th {
  padding-left: 1.5em;
  padding-bottom: 0.5em;
  font-weight: 600;
}
